import React from "react";

const qrGeneratedFromShownValues = {
	crm: "Creative Manager",
	imposium: "Imposium",
};

export const QrGeneratedFrom = ({ value }) => {
	return (
		<div className="qr-generated-from-col">
			<span className="generated-from name-overflow" data-testid={'qr-generated-from-span'}>
				{qrGeneratedFromShownValues[value] || value}
			</span>
		</div>
	);
};
